import React, { useState } from 'react';
import { SectionDivider } from '../components/Layout';

export default function ContactPage() {
  const [formData, setFormData] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('/api/contact.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok && result.success) {
        alert('お問い合わせを受け付けました。後日担当者よりご連絡いたします。');
        // フォームリセット
        setFormData({
          company: '',
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        alert('全ての必須項目（*）を入力してください。');
      }
    } catch (error) {
      console.error('送信エラー:', error);
      alert('通信エラーが発生しました。インターネット接続をご確認ください。');
    }
  };

  return (
    <div className="min-h-screen">
      
      {/* ヒーローセクション */}
      <section 
        className="h-80 md:h-screen flex items-end justify-end relative pb-12 pr-12 pl-4 md:pl-48"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/images/hero/contact_hero_mobile.jpg")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* PCバージョン背景画像 */}
        <div 
          className="hidden md:block absolute inset-0 z-0"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url("/images/hero/contact_hero_desktop.jpg")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
        
        <div className="text-right relative z-10">
          <h1 className="font-bold text-white leading-tight" style={{
            fontSize: window.innerWidth >= 768 ? '56px' : '24px',
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
          }}>
            <span style={{color: '#fed7aa'}}>ご質問・ご相談</span><br />
            お待ちしております。
          </h1>
        </div>
      </section>

      {/* SVG区切り1 */}
      <SectionDivider title="contact" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* お問い合わせフォームセクション */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="heading-1 mb-4" style={{color: '#8b4513'}}>
                  お問い合わせフォーム
                </h2>
                <p className="body-text leading-relaxed" style={{color: '#8b4513', opacity: 0.8}}>
                  農作物について、取引に関するお問い合わせ、<br />
                  農園見学について、メディア取材のご依頼など、<br />
                  その他ご質問・ご相談がございましたら下記フォームにお書きください。
                </p>
              </div>
              
              {/* お問い合わせフォーム */}
              <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8 mb-8" style={{border: '1px solid #e5d3b3'}}>
                <div className="space-y-6">
                  
                  {/* 事業者名・会社名 */}
                  <div>
                    <label className="block heading-3 mb-2" style={{color: '#8b4513'}}>
                      事業者名・会社名
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:border-orange-400 body-text"
                      style={{borderColor: '#e5d3b3'}}
                      placeholder="立石農園株式会社"
                    />
                  </div>

                  {/* お名前 */}
                  <div>
                    <label className="block heading-3 mb-2" style={{color: '#8b4513'}}>
                      お名前 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:border-orange-400 body-text"
                      style={{borderColor: '#e5d3b3'}}
                      placeholder="山田 太郎"
                    />
                  </div>

                  {/* メールアドレス */}
                  <div>
                    <label className="block heading-3 mb-2" style={{color: '#8b4513'}}>
                      メールアドレス <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:border-orange-400 body-text"
                      style={{borderColor: '#e5d3b3'}}
                      placeholder="example@email.com"
                    />
                  </div>

                  {/* 電話番号 */}
                  <div>
                    <label className="block heading-3 mb-2" style={{color: '#8b4513'}}>
                      電話番号
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:border-orange-400 body-text"
                      style={{borderColor: '#e5d3b3'}}
                      placeholder="090-1234-5678"
                    />
                  </div>

                  {/* 件名 */}
                  <div>
                    <label className="block heading-3 mb-2" style={{color: '#8b4513'}}>
                      件名 <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:border-orange-400 body-text"
                      style={{borderColor: '#e5d3b3', color: '#8b4513'}}
                    >
                      <option value="">選択してください</option>
                      <option value="取引について">取引について</option>
                      <option value="農園見学について">農園見学について</option>
                      <option value="メディア取材について">メディア取材について</option>
                      <option value="その他">その他</option>
                    </select>
                  </div>

                  {/* お問い合わせ内容 */}
                  <div>
                    <label className="block heading-3 mb-2" style={{color: '#8b4513'}}>
                      お問い合わせ内容 <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="6"
                      className="w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:border-orange-400 body-text"
                      style={{borderColor: '#e5d3b3'}}
                      placeholder="お問い合わせ内容をご記入ください"
                    />
                  </div>

                  {/* 送信ボタン */}
                  <div className="text-center pt-4">
                    <button
                      onClick={handleSubmit}
                      className="bg-red-500 hover:bg-red-600 text-white px-8 py-4 rounded-lg font-bold transition-colors heading-3 shadow-md"
                    >
                      送信する
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>

      {/* SVG区切り2 */}
      <SectionDivider title="information" />

      <div className="tateishi-content ml-0 md:ml-40">
        <div className="max-w-4xl mx-auto">

          {/* 農園基本情報・アクセスセクション */}
          <section className="tateishi-section">
            <div className="-mx-4 md:px-6 text-center">
              <div className="bg-white rounded-2xl shadow-sm p-6 md:p-8" style={{border: '1px solid #e5d3b3'}}>
                <div className="responsive-grid-2">
                  {/* 基本情報 */}
                  <div>
                    <h3 className="heading-2 mb-4" style={{color: '#8b4513'}}>基本情報</h3>
                    <div className="space-y-4 body-text" style={{color: '#8b4513', opacity: 0.8}}>
                      <div>
                        <p className="font-bold mb-1" style={{color: '#8b4513'}}>農園名</p>
                        <p>立石農園</p>
                      </div>
                      <div>
                        <p className="font-bold mb-1" style={{color: '#8b4513'}}>代表者</p>
                        <p>立石瑛人</p>
                      </div>
                      <div>
                        <p className="font-bold mb-1" style={{color: '#8b4513'}}>住所</p>
                        <p>〒849-4274<br />佐賀県伊万里市東山代町脇野4980-3</p>
                      </div>
                    </div>
                  </div>

                  {/* アクセス・営業情報 */}
                  <div>
                    <h3 className="heading-2 mb-4" style={{color: '#8b4513'}}>アクセス・営業情報</h3>
                    <div className="space-y-4 body-text" style={{color: '#8b4513', opacity: 0.8}}>
                      <div>
                        <p className="font-bold mb-1" style={{color: '#8b4513'}}>最寄り駅</p>
                        <p>JR筑肥線 伊万里駅より車で約15分</p>
                      </div>
                      <div>
                        <p className="font-bold mb-1" style={{color: '#8b4513'}}>車でのアクセス</p>
                        <p>長崎自動車道 武雄北方ICより約20分</p>
                      </div>
                      <div>
                        <p className="font-bold mb-1" style={{color: '#8b4513'}}>見学について</p>
                        <p>農園見学は事前予約制となっております。<br />お電話またはSNSよりお気軽にお問い合わせください。</p>
                      </div>
                      <div>
                        <p className="font-bold mb-1" style={{color: '#8b4513'}}>通販について</p>
                        <p>さつまいも「紅はるか」の通販は収穫期（10-11月）に<br />メルカリにて販売予定です。</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 地図エリア */}
                <div className="mt-8">
                  <h3 className="heading-2 mb-4 text-center" style={{color: '#8b4513'}}>アクセスマップ</h3>
                  <div className="rounded-xl overflow-hidden shadow-lg h-48 md:h-96">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3340.1234567890123!2d129.8765432109876!3d33.2345678901234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDE0JzA0LjQiTiAxMjnCsDUyJzM1LjYiRQ!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp&q=佐賀県伊万里市東山代町脇野4980-3"
                      width="100%"
                      height="100%"
                      style={{border: 0}}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="立石農園の地図"
                    ></iframe>
                  </div>
                  <p className="text-center mt-4 caption-text" style={{color: '#8b4513', opacity: 0.7}}>
                    詳細な場所については、お問い合わせ時にご案内いたします
                  </p>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
}